import { array, boolean, defineAction, object, string } from '~/prix'
import getMonitorUserPermissions from './getMonitorUserPermissions.action.json'

const getMonitorUserPermissionsDefinition = defineAction({
  ...getMonitorUserPermissions,
  input: object({}),
  output: object({
    isAdmin: boolean(),
    items: array(
      object({
        key: string(),
        label: string(),
        description: string().isOptional(),
        type: string(),
        sectorKey: string().isOptional(),
        isEnabled: boolean(),
      }),
    ),
  }),
})

export default getMonitorUserPermissionsDefinition
